import React from 'react';

const OpenSource = () => (
  <section className="section open-source-section" id="open-source" aria-labelledby="open-source-title">
    <div className="shell open-source-grid">
      <div className="section-heading">
        <span className="section-number">05 / OPEN SOURCE</span>
        <h2 id="open-source-title">Contributing<br />upstream.</h2>
        <p>GitLab.org / contributor-success</p>
      </div>

      <div className="open-source-content">
        <article className="open-source-panel">
          <div className="open-source-top">
            <div className="open-source-brand">
              <img src="/gitlab-mark.svg" alt="" width="48" height="48" />
              <div>
                <strong>GitLab</strong>
                <span className="mono">OPEN SOURCE</span>
              </div>
            </div>
            <span className="open-source-count mono">02 MERGE REQUESTS</span>
          </div>
          <h3>Contributing to GitLab's contributor platform</h3>
          <p className="open-source-intro">
            A merged model naming fix and a follow-up service refactor submitted through GitLab's contributor platform.
          </p>

          <div className="contribution-list">
            <div className="contribution-item">
              <span className="contribution-number">!1878 <small>Merged</small></span>
              <div>
                <h4>Model naming &amp; compatibility</h4>
                <p>Resolved a model namespace conflict while preserving database and API compatibility.</p>
              </div>
            </div>
            <div className="contribution-item">
              <span className="contribution-number">!2707 <small>Submitted</small></span>
              <div>
                <h4>Service architecture</h4>
                <p>Refactored the bonus points service into a dedicated namespace, updating integrations, user validation, and tests.</p>
              </div>
            </div>
          </div>

          <p className="open-source-outcome">
            Ruby on Rails work spanning model and API compatibility, service boundaries, validation, and tests.
          </p>
          <a className="text-link" href="https://gitlab.com/mhdnihas" target="_blank" rel="noopener noreferrer">
            View GitLab profile <span aria-hidden="true">↗</span>
          </a>
        </article>

        <div className="contributor-score">
          <div className="contributor-score-heading">
            <span className="mono">CONTRIBUTOR SCORE</span>
            <span>Live from GitLab Contributors</span>
          </div>
          <div className="contributor-banner-scroll" role="region" aria-label="GitLab contributor score banner" tabIndex="0">
            <img
              src="https://contributors.gitlab.com/users/mhdnihas/banner.svg"
              alt="Muhammed Nihas's GitLab contributor score and activity"
              width="840"
              height="200"
              loading="lazy"
            />
          </div>
          <p className="contributor-score-hint">Scroll to see the full score <span aria-hidden="true">→</span></p>
        </div>
      </div>
    </div>
  </section>
);

export default OpenSource;
